import { UNFINISHED_FEATURE_ENVIRONMENTS } from "../../../../../shared/components/filters/constants/filterMenuConst"
import { useMatchEnvironment } from "../../../../environment/envHooks"

import { IdCardsTable } from "../components/IdCardsTable"
import { MerchantIdCardsHeader } from "../components/MerchantIdCardsHeader"
import { IdCardsList } from "../list/components/IdCardsList"

type Props = Readonly<{}>

export function MerchantIdCards({}: Props) {
    // the new list runs on mock data until the ID cards API exists
    const showIdCardsList = useMatchEnvironment(UNFINISHED_FEATURE_ENVIRONMENTS)

    if (showIdCardsList) return <IdCardsList />

    return (
        <>
            <MerchantIdCardsHeader />
            <IdCardsTable />
        </>
    )
}
